<img class="hoverable-icon" [src]="iconPath" (mouseenter)="mouseOn()" (mouseleave)="mouseOff()" />
